import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';


export const subModulesMixin = {
    computed: {
        ...rootMapState(usePageStore, {
            "moduleData": store => store.moduleData
        }),
        
        quickSearchData() {
            return this.loadSubModule('md-quick-search')
        },
        searchSeoData() {
            return this.loadSubModule('md-search-seo')
        },
        footerData() {
            return this.loadSubModule('md-footer')
        }
    },
    methods: {
        // 初始化子模块配置
        loadSubModule(mdName) {
            var index = this.moduleData.findIndex(md => md.id === this.id);
            if (index !== -1) {
                var list = this.moduleData.slice(index + 1);
                return list.find(md => md.name === mdName);
            }
            return 
        }
    }
};

// 初始化子模块
export function initSubModules(vm) {
    // this.quickSearchData = this.loadSubModule('md-quick-search');
    // if (this.quickSearchData?.comp) {
    //     vm.appContext.components['md-quick-search'] = this.quickSearchData.comp;
    // }
    // this.searchSeoData = this.loadSubModule('md-search-seo');
    // if (this.searchSeoData?.comp) {
    //     vm.appContext.components['md-search-seo'] = this.searchSeoData.comp;
    // }
    // this.footerData =  this.loadSubModule('md-footer');
    // if (this.footerData?.comp) {
    //     vm.appContext.components['md-footer'] = this.footerData.comp;
    // }
}
